import { render, staticRenderFns } from "./BrandsFilters.vue?vue&type=template&id=02c69494&"
import script from "./BrandsFilters.vue?vue&type=script&lang=js&"
export * from "./BrandsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports